"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section ref={ref} className="relative flex min-h-screen items-center justify-center overflow-hidden bg-dark-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center !bg-[url(https://guillermobogao.com/wp-content/uploads/2026/02/CA8BD950-C2BE-48DE-BCB0-511650AB0804.png)] transition-transform duration-[8000ms] ease-out !opacity-[0.25]" style={{
      transform: isVisible ? "scale(1.05)" : "scale(1)"
    }} />

      {}
      

      {}
      <div className="relative z-10 mx-auto max-w-4xl px-6 text-center">
        {}
        <h1 className="font-display text-4xl leading-tight transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] translate-y-0 opacity-100 !shadow-none !font-semibold !text-[hsl(0,0%,100%)] md:text-5xl lg:text-6xl">¿Sientes que estás estancado y podrías dar más?</h1>

        {}
        <p className="mt-6 text-lg font-normal leading-relaxed transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] delay-100 translate-y-0 opacity-100 !text-[hsl(0,0%,100%)] md:text-xl">Te acompaño a ordenar tu mente, romper bloqueos y avanzar con claridad, confianza y dirección.</p>

        {}
        <div className={`mt-10 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] delay-200 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
          <a href="https://guillermobogao.com/sesion" target="_blank" rel="noopener noreferrer">
  <Button size="lg" className="bg-primary text-foreground-primary px-8 py-4 text-base font-medium">
    Dar el primer paso
  </Button>
        </a>
        </div>
      </div>
    </section>;
}